/* Auto-generated from authentication-schemas.proto */
export var IdentityProvider;
(function (IdentityProvider) {
    IdentityProvider[IdentityProvider["Unknown"] = 0] = "Unknown";
    IdentityProvider[IdentityProvider["LiveId"] = 1] = "LiveId";
    IdentityProvider[IdentityProvider["OrgId"] = 2] = "OrgId";
    IdentityProvider[IdentityProvider["ActiveDirectory"] = 3] = "ActiveDirectory";
    IdentityProvider[IdentityProvider["ADAL"] = 4] = "ADAL";
    IdentityProvider[IdentityProvider["SSPI"] = 5] = "SSPI";
    IdentityProvider[IdentityProvider["OAuth2"] = 6] = "OAuth2";
    IdentityProvider[IdentityProvider["Badger"] = 7] = "Badger";
})(IdentityProvider || (IdentityProvider = {}));
export var AuthTokenType;
(function (AuthTokenType) {
    AuthTokenType[AuthTokenType["Augloop"] = 0] = "Augloop";
    AuthTokenType[AuthTokenType["Substrate"] = 1] = "Substrate";
})(AuthTokenType || (AuthTokenType = {}));
//# sourceMappingURL=authentication-schemas.js.map